<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">文件管理</div>
      <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item label="文件名称">
          <el-input v-model="fileNmae" placeholder="请输入文件名称"></el-input>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-button-bar" v-show="disabledUpload">
        <el-upload
          :http-request="httpRequest"
          :show-file-list="false"
          :before-upload="beforeupload"
          :on-success="uploadsuccess"
          :on-progress="uploadProgress"
          :on-error="uploadError"
          :data="uploadData"
          :file-list="fileList"
        >
          <!-- <el-button size="mini" @click="onAdd">添 加</el-button> -->
          <el-button size="mini" type="primary">上 传</el-button>
        </el-upload>
      </div>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="FileName" label="文件名称"></el-table-column>
            <el-table-column prop="FileSize" label="文件大小"></el-table-column>
            <el-table-column prop="Extension" label="后缀名"></el-table-column>
            <el-table-column prop="CreateTime" label="上传日期" :formatter="formatDate"></el-table-column>
            <el-table-column prop="AssocModule" label="模块名称"></el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button @click="DownLoad(scope.$index, scope.row)" type="text" size="small">下载</el-button>
                <el-button @click="DeleteFile(scope.$index, scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
export default {
  name: "FileList",
  controller: "UI",
  action: "FileList",
  props: {
    assocID: String,
    module: String,
    submodule: String,
    disabledUpload: { type: Boolean, default: true },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      fileNmae: "",
      loading: false,
      loadingText: "加载中...",
      tableData: [],
      uploadData: {
        //todo
        module: "", //模块名
        submodule: "", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      fileList: [],
    };
  },
  created: function () {
    this.uploadData.assocID = this.assocID ?? ZJApp.ZJUtils.uuid();
    this.uploadData.module = this.module ?? "";
    this.uploadData.submodule = this.submodule ?? "";
    this.search();
  },
  mounted: function () {},
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.fileNmae = "";
      this.FileCategory = "";
      this.FileType = "";
    },
    onAdd() {
      this.$router.push({
        path: "/plugin/MaterialManage/UI/MaterialInfo",
        query: {
          type: "add",
        },
      });
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    search() {
      let searchinfo = {
        FileName: this.fileNmae,
        AssocModule: this.uploadData.module,
        AssocID: this.uploadData.assocID,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      this.loadingText = "加载中...";
      this.loading = true;
      new MyApis.FileApi()
        .GetFileList(searchinfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.FileList;
          this.total = r.RecordCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    DownLoad(index, row) {
      var downloadpath = row.DownloadPath;
      window.location.href = downloadpath;
      //window.open(downloadpath);
    },
    DeleteFile(index, row) {
      var ids = [];
      ids.push(row.FileID);
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        new MyApis.FileApi()
          .DeleteFile(ids)
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.loading = false;
            this.search();
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      });
    },
    beforeupload: function () {
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function () {
      this.loading = false;
      this.search();
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
  },
};
</script>
